import { render, staticRenderFns } from "./gBottom.vue?vue&type=template&id=15a2fee4&scoped=true&"
import script from "./gBottom.vue?vue&type=script&lang=js&"
export * from "./gBottom.vue?vue&type=script&lang=js&"
import style0 from "./gBottom.vue?vue&type=style&index=0&id=15a2fee4&lang=scss&scoped=true&"
import style1 from "./gBottom.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a2fee4",
  null
  
)

export default component.exports